import React from 'react';
import PropTypes from 'prop-types';
import useCountdownTimer from '../common/hooks/useCountdownTimer';

function AuctionTimeLabel({ item }) {
  const valueToDisplay = useCountdownTimer(item?.publishSecondsLeft);
  const renderAuctionTime = () => (
    <div>
      <p className="search-time m-0 search">{valueToDisplay}</p>
    </div>
  );

  return renderAuctionTime();
}

AuctionTimeLabel.defaultProps = {
  item: null,
  windowFocus: false,
  auctionTimestamp: 0,
};

AuctionTimeLabel.propTypes = {
  item: PropTypes.object,
  windowFocus: PropTypes.bool,
  auctionTimestamp: PropTypes.any,
  listType: PropTypes.string,
  organizationId: PropTypes.string,
};

export default AuctionTimeLabel;
